export const toFixedDecimal = (num: number, maxNum: number = -1) => {
  if (Number.isInteger(num) || !Number.isFinite(num)) return num;
  const cLength = num.toString().split(".")[1].length;
  const decimal = maxNum > -1 && cLength > maxNum ? maxNum : cLength;
  return num.toFixed(decimal);
};
